import { GameManual } from '../../types';

/** Legacy GameManual stub — Odin uses dedicated screens. */
export const odinDeluxeLegacyManualStub: GameManual = {
  chapters: [],
  firstGameSteps: [],
};
